export const TEAM_PREPARATION_PAGES = [
  {id: "protocols", label: "Protocols", path: "/team-center/protocols", requiresSubscription: true},
  {id: "veto", label: "Team Decisions", path: "/team-center/team-decisions", requiresSubscription: true},
  {id: "my-homework", label: "Drills & Exercises", path: "/team-center/homework"},
];

export const LEGACY_PREP_PATHS = ['/team-center/team-voting','/team-center/prep-overview','/team-center/prep-input','/team-center/improvement-notes','/team-center/match-prep'];
export const prepPanelAlias = id => ({sessions:'event-prep',notes:'event-prep','match-prep':'event-prep','prep-overview':'event-prep','prep-input':'event-prep'}[id] || id);
